import React from 'react';
import FieldSelectAutoComplete from '../configuration/fields/FieldSelectAutoComplete';

export default class IndexTableFiltersPanelMultiSelect extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange = item => {
        let items = this.getItems();
        let selectedItem = items.find(x => x.value === item);

        // let values= props.value||  [];
        // values.push(item);
        let index = items.indexOf(selectedItem);
        this.props.onChange({
            text: selectedItem.text,
            value: item,
            index: index
        })
    }

    getItems = () => this.props.prop.values.items;

    render() {
        let {value, label} = this.props;

        let values = value || [];
        if (!Array.isArray(values))
            values = [values];

        let items = this.getItems().filter(i => {
            return !values.includes(i.value)
        });

        return (
            <div className="filters-panel-input">
                <span title={label}>{label}</span>
                <span>
                    <FieldSelectAutoComplete
                        items={items}
                        value={values}
                        forceReadable={true}
                        forceNonPortal={true}
                        onChange={(e) => this.onChange(e)}
                    />
                </span>
            </div>
        )
    }

}